import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {
  AddCondition,
  AddGroupId,
  AddFloorId,
  DeselectConditionSuccess,
  DeselectFloorIdSuccess,
  DeselectGroupIdSuccess,
  DeviceGridViewActionTypes,
  HoverDevice,
  HoverDeviceSuccess,
  HoverOutSuccess,
  RemoveCondition,
  RemoveGroupId,
  RemoveFloorId,
  SelectCondition,
  SelectFloorId,
  SelectGroupId,
} from '../actions/device-grid-view.actions';
import {map, withLatestFrom} from 'rxjs/operators';
import {HoverDevicePayload, SelectGroupIdPayload, SelectFloorIdPayload} from '../models/device-grid';
import {Condition} from '../../afb-api/enums/condition.enum';

import * as fromDeviceGrid from '../reducers';
import {select, Store} from '@ngrx/store';

@Injectable()
export class DeviceGridViewEffects {

  @Effect()
  hoverDevice$ = this.actions$.pipe(
    ofType(DeviceGridViewActionTypes.HoverDevice),
    map((action: HoverDevice) => action.payload),
    map((hoverDevicePayload: HoverDevicePayload) => new HoverDeviceSuccess(hoverDevicePayload))
  );

  @Effect()
  hoverOut$ = this.actions$.pipe(
    ofType(DeviceGridViewActionTypes.HoverOut),
    map(() => new HoverOutSuccess())
  );

  @Effect()
  selectCondition$ = this.actions$.pipe(
    ofType(DeviceGridViewActionTypes.SelectCondition),
    map((action: SelectCondition) => action.payload),
    withLatestFrom(this.state$.pipe(
      select(fromDeviceGrid.selectedConditions)
    )),
    map(([selectedCondition, selectedConditions]: [Condition, Condition[]]) => {
      const foundCondition: boolean = selectedConditions.some(
        (condition: Condition) => selectedCondition === condition
      );

      return foundCondition ? new RemoveCondition(selectedCondition) :
        new AddCondition(selectedCondition);
    })
  );

  @Effect()
  deselectCondition$ = this.actions$.pipe(
    ofType(DeviceGridViewActionTypes.DeselectCondition),
    map(() => new DeselectConditionSuccess())
  );

  @Effect()
  selectGroupId$ = this.actions$.pipe(
    ofType(DeviceGridViewActionTypes.SelectGroupId),
    map((action: SelectGroupId) => action.payload),
    map((selectedGroupIdPayload: SelectGroupIdPayload) => selectedGroupIdPayload.groupId),
    withLatestFrom(this.state$.pipe(
      select(fromDeviceGrid.selectedGroupIds)
    )),
    map(([groupId, selectedGroupIds]: [string, string[]]) => {
      const foundGroupId: boolean = selectedGroupIds.some(
        (selectedGroupId: string) => groupId === selectedGroupId
      );

      return foundGroupId ? new RemoveGroupId({groupId}) :
        new AddGroupId({groupId});
    })
  );

  @Effect()
  deselectGroupId$ = this.actions$.pipe(
    ofType(DeviceGridViewActionTypes.DeselectGroupId),
    map(() => new DeselectGroupIdSuccess())
  );

  @Effect()
  selectFloorId$ = this.actions$.pipe(
    ofType(DeviceGridViewActionTypes.SelectFloorId),
    map((action: SelectFloorId) => action.payload),
    map((selectedFloorIdPayload: SelectFloorIdPayload) => selectedFloorIdPayload.floorId),
    withLatestFrom(this.state$.pipe(
      select(fromDeviceGrid.selectedFloorIds)
    )),
    map(([floorId, selectedFloorIds]: [string, string[]]) => {
      const foundFloorId: boolean = selectedFloorIds.some(
        (selectedFloorId: string) => selectedFloorId === floorId
      );

      return foundFloorId ? new RemoveFloorId({floorId}) :
        new AddFloorId({floorId});
    })
  );

  @Effect()
  deselectFloorId$ = this.actions$.pipe(
    ofType(DeviceGridViewActionTypes.DeselectFloorId),
    map(() => new DeselectFloorIdSuccess())
  );

  constructor(private actions$: Actions,
              private state$: Store<fromDeviceGrid.State>) {
  }
}
